export const UPGRADE_PATHS = Object.freeze({
  INITIAL: "/",
  PLAN_DETAILS: "/plan_details",
  UPGRADE_SUCCESSFUL: "/upgrade_successful",
  BLOCKED_UPGRADE: "/blocked_upgrade",
  LOADING: "/loading",
  WORKFLOW_APP_SYNCING: "/workflow_app_syncing",
  ERROR: "/error",
  PRORATION: "/proration",
  CAN_DOWNGRADE: "/can_downgrade",
  EMAIL_HUB_SUBSCRIPTION_CHECK: "/email_hub_subscription_check",
  BLOCK_PLAN_TRIAL_DOWNGRADE: "/block_plan_trial_downgrade",
  SCHEDULED_DOWNGRADE_CONFIRMATION: "/scheduled_downgrade_confirmation",
  SCHEDULED_DOWNGRADE_SUCCESS: "/scheduled_downgrade_success",
  CANCEL_SCHEDULED_DOWNGRADE_MODAL: "/cancel_scheduled_downgrade_modal",
  RENEWAL: "/renewal",
});

export const UPGRADE_FLOW_SOURCES = Object.freeze({
  COMMUNITY_AI_SPLASH_SCREEN: "community_ai_splash_screen",
  ACTIVITY_LOGS: "activity_logs",
  ACTIVITY_SCORES_FILTER_CHIP: "activity_scores_filter_chip",
  ACTIVITY_SCORES_SCORE_CHIP: "activity_scores_score_chip",
  ACTIVITY_LOGS_SPLASH_SCREEN: "activity_logs_splash_screen",
  PROFILE_FIELDS_FILTER_CHIP: "profile_fields_filter_chip",
  PROFILE_FIELDS_SPLASH_SCREEN: "profile_fields_splash_screen",
  PROFILE_FIELDS_ANALYTICS_FILTER_CHIP: "profile_fields_analytics_filter_chip",
  COPILOT_UPGRADE_MODAL: "copilot_upgrade_modal",
  WORKFLOWS_UPGRADE_MODAL: "workflows_upgrade_modal",
  SPACE_LIMIT_UPGRADE_MODAL: "space_limit_upgrade_modal",
  ANALYTICS_FILTERS: "ANALYTICS_FILTERS",
  API_KEY_SPLASH_SCREEN: "api_key_splash_screen",
  API_KEY_CREATION_SCREEN: "api_key_creation_screen",
  CODE_SNIPPETS_SPLASH_SCREEN: "code_snipets_splash_screen",
  MODERATION_SETTINGS_SPLASH_SCREEN: "moderation_settings_splash_screen",
  INVITE_MEMBERS_MODAL: "invite_members_modal",
  ONBOARDING_WORKFLOWS_MODAL: "onboarding_workflows_modal",
  PAYWALLS_WORKFLOWS_MODAL: "paywalls_workflows_modal",
  SPACE_WORKFLOWS_MODAL: "space_workflows_modal",
  EMAIL_HUB_LANDING_PAGE: "email_hub_landing_page",
  COMMUNITY_VISIBILITY_SETTINGS: "community_visibility_settings",
  AI_AGENTS_ENABLE_MODAL: "ai_agents_enable_modal",
  AI_ACTIONS_ENABLE_MODAL: "ai_actions_enable_modal",
  ENTERPRISE_PRICE_INCREASE_BANNER: "enterprise_price_increase_banner",
  WEBSITE_BUILDER_SPLASH_SCREEN: "website_builder_splash_screen",
});

export const SCHEDULED_DOWNGRADE_TYPES = Object.freeze({
  PLAN_DOWNGRADE: "plan_downgrade",
  INTERVAL_DOWNGRADE: "interval_downgrade",
});

export type ScheduledDowngradeType = "plan_downgrade" | "interval_downgrade";
